
export const SET_STATISTICS_LOADING_EXPORT = 'SET_STATISTICS_LOADING_EXPORT'
export const SET_STATISTICS_LOADING = 'SET_STATISTICS_LOADING'
export const SET_COUPON_DETAILS_DATA = 'SET_COUPON_DETAILS_DATA'
export const SET_FUNDS_DETAILS_DATA = 'SET_FUNDS_DETAILS_DATA'
export const SET_REGISTRATIONS_DATA = 'SET_REGISTRATIONS_DATA'
export const SET_CAPACITY_DATA = 'SET_CAPACITY_DATA'
export const SET_TASK_CAPACITY_DATA = 'SET_TASK_CAPACITY_DATA'
export const SET_SUBMIT_TASK_COUNT_DATA = 'SET_SUBMIT_TASK_COUNT_DATA'
export const SET_REPURCHASE_RATE_DATA = 'SET_REPURCHASE_RATE_DATA'
export const SET_USER_BALANCE_DATA = 'SET_USER_BALANCE_DATA'
export const SET_RECHARGE_DETAILS_DATA = 'SET_RECHARGE_DETAILS_DATA'
export const SET_INCOME_DATA = 'SET_INCOME_DATA'
export const SET_ACHIEVEMENT_LIST = 'SET_ACHIEVEMENT_LIST'
export const SET_ACHIEVEMENT_LIST_LOADING = 'SET_ACHIEVEMENT_LIST_LOADING'
export const SET_ACHIEVEMENT_AMOUNT = 'SET_ACHIEVEMENT_AMOUNT'
export const SET_REMARK_DATA = 'SET_REMARK_DATA'
